import builtins from './builtins';

function i18nGet(data, locale) {
  if (!data) return '';

  const type = typeof data;
  if (type === 'string') {
    return data;
  } if (type === 'object') {
    return data[locale];
  }

  return String(data);
}

export default class Validation {
  static create(state, options, context) {
    return new Validation(state, options, context);
  }

  constructor(state, { rules, validators, locale }, context) {
    this.validators = {
      ...builtins,
      ...validators,
    };
    this.state = state;
    this.rules = (this.validators.defaultRules || []).concat(rules || []);
    this.locale = locale;
    this.ctx = context;
  }

  disable() {
    this.disabled = true;
  }

  enable() {
    this.disabled = false;
  }

  isEmpty(value, state) {
    return !this.validators.required.valid(value, null, state);
  }

  setRules(rules) {
    this.rules = rules;
  }

  valid(targetKeys, force) {
    if (this.disabled || (this.rules.length < 1 && !this.validators.extraValidation)) {
      return null;
    }

    if (targetKeys && Array.isArray(targetKeys)) {
      // targetKeys中会有对应的path，只需要最后一部分进行校验即可
      if (!this.validators.validationKeys.some(key => ~targetKeys.map(keys => keys.substring(keys.indexOf('/') + 1))
        .indexOf(key))) {
        return null;
      }
    }

    // todo: abstract
    const behavior = this.state.getValue('behavior/fieldBehavior');
    if (behavior === 'DISABLED' || behavior === 'READONLY' || behavior === 'HIDDEN') {
      return null;
    }

    this.disabled = true;

    const { state } = this;
    const defaultFormatter = this.validators.defaultValueFormatter;

    let errorMsg = null;
    let hasError = this.rules.some((rule) => {
      if (typeof rule === 'string') {
        rule = { type: rule };
      }

      const validator = this.validators[rule.type];
      if (!validator) {
        return false;
      }

      const formatter = validator.valueFormatter || defaultFormatter;

      if (this.isEmpty(formatter(state), state)) {
        if (rule.type === 'required') {
          errorMsg = this.getDefaultMessage(rule, validator, state.getValue('label'));
          return true;
        }
        return false;
      }

      if (validator.valid(formatter(state), rule.param, state, this.ctx)) {
        return false;
      }

      errorMsg = this.getDefaultMessage(rule, validator, state.getValue('label'));
      return true;
    });

    if (!hasError && this.validators.extraValidation) {
      const ret = this.validators.extraValidation(state, force);
      if (ret) {
        ({ hasError } = ret);
        ({ errorMsg } = ret);
      }
    }

    const res = { hasError, errorMsg };

    state.mergeData(res, [this.state.id]);

    this.disabled = false;

    return res;
  }

  getDefaultMessage(rule, validator, label) {
    if (rule.message) {
      return rule.message;
    }
    const defaultMessage = i18nGet(validator.defaultMessage, this.locale);
    const params = [label];
    if (rule.param) {
      params.push(rule.param);
    }
    return params.reduce(
      (message, param) => message.replace('%s', param || ''),
      defaultMessage
    );
  }
}
